import { getURLSearchParamsFromQuery } from '@schibsted-nmp/search-frontend-clients';
import React from 'react';
import { useAppConfig } from '../AppConfig';
import type { SearchParams } from './AppStateTypes';

export function useLocationUrl(): {
    locationUrl: URL;
    locationUrlRef: React.MutableRefObject<URL>;
} {
    const { originalUrl } = useAppConfig();
    const isServer = typeof window === 'undefined';

    const isomorphicLocationUrl = isServer ? originalUrl : window.location.href;

    const locationUrl = React.useMemo(
        () => new URL(isomorphicLocationUrl),
        [isomorphicLocationUrl],
    );

    const locationUrlRef = React.useRef(locationUrl);

    React.useEffect(
        function updateRefWhenUrlChanges() {
            locationUrlRef.current = locationUrl;
        },
        [locationUrl],
    );

    return { locationUrl, locationUrlRef };
}

export function getUrlWithSortedSearchParams(
    url: URL,
    searchParams?: SearchParams,
): URL {
    const sortedParams = searchParams
        ? getURLSearchParamsFromQuery(searchParams)
        : new URLSearchParams(url.search);
    sortedParams.sort();

    const sortedParamsUrl = new URL(url.href);
    sortedParamsUrl.search = sortedParams.toString();

    return sortedParamsUrl;
}
